import {RouterModule, Routes} from '@angular/router';

import {StatisticComponent} from './statistic.component';
import {ListComponent} from './list/list.component';

// noinspection TypeScriptValidateTypes
const routes: Routes = [
  {
    path: '',
    component: StatisticComponent,
    children: [
      { path: '', redirectTo: 'list', pathMatch: 'full' },
      { path: 'list', component: ListComponent },
    ]
  }
];

export const routing = RouterModule.forChild(routes);



// WEBPACK FOOTER //
// /app/src/app/pages/admin/qrcode/statistic/statistic.routing.ts